import Api from '@/api/api.js'

export default {
    getListeFicheConsultation(type_consultation_id) {
        const promise = Api().get('/fiche-consultation/'+type_consultation_id+'/liste-fiche-par-type-consultation')
        return promise.then(response => response.data)
    },

    saveFicheConsultation(data) {
        const promise = Api().post('/fiche-consultation/store', data)
        return promise.then(response => response.data)
    },

    getSectionByTypeConsultation(data) {
        const promise = Api().post('/fiche-consultation/liste-section', data)
        return promise.then(response => response.data)
    },

    saveFicheSectionOrder(data) {
        const promise = Api().post('/fiche-consultation/sections/re-ordonner', data)
        return promise.then(response => response.data)
    },

    saveFicheChampOrder(data) {
        const promise = Api().post('/fiche-consultation/champs/re-ordonner', data)
        return promise.then(response => response.data)
    },

    saveSectionFicheConsultation(data) {
        const promise = Api().post('/fiche-consultation/sections/store', data)
        return promise.then(response => response.data)
    },

    geListeChampByFicheSection(data) {
        const promise = Api().post('/fiche-consultation/sections/liste-champs', data)
        return promise.then(response => response.data)
    },

    editerNomSection(data) {
        const promise = Api().post('/fiche-consultation/sections/editer-nom', data)
        return promise.then(response => response.data)
    },

    gererChampsFicheConsultation(data) {
        const promise = Api().post('/fiche-consultation/sections/gerer-champs', data)
        return promise.then(response => response.data)
    },

    geAllChampsByDataType(data_type) {
        const promise = Api().get('/champs/liste-par-type/'+data_type+'/liste')
        return promise.then(response => response.data)
    },

    updateChampListe(data) {
        const promise = Api().post('/fiche-consultation/champs/manage-activation', data)
        return promise.then(response => response.data)
    },

    checkUserAccessOnTypePrestation(data) {
        const promise = Api().post('/accessibilites/user/type-prestation', data)
        return promise.then(response => response.data)
    },

    saveDefaultFicheConsultation(data) {
        const promise = Api().post('/fiche-consultation/set-default', data)
        return promise.then(response => response.data)
    },

    getListeFicheConsultationSection(data) {
        const promise = Api().post('/fiche-consultation/consultation/liste-fiche-section', data)
        return promise.then(response => response.data)
    },

    getGroupedFicheConsultation() {
        const promise = Api().get('/fiche-consultation/grouped-fiche')
        return promise.then(response => response.data)
    },

    startConsultation(data) {
        const promise = Api().post('/fiche-consultation/start-consultation', data)
        return promise.then(response => response.data)
    },

    saveConsultationFicheSectionData(data) {
        const promise = Api().post('/fiche-consultation/store/consultation-data', data)
        return promise.then(response => response.data)
    },

    getCustomConsultationSectionData(data) {
        const promise = Api().post('/fiche-consultation/consultation/get-custom-section-data', data)
        return promise.then(response => response.data)
    },

    saveCustomSectionData(data) {
        const promise = Api().post('/fiche-consultation/custom-section/store', data)
        return promise.then(response => response.data)
    },

    getCustomSectionContent(data) {
        const promise = Api().post('/fiche-consultation/custom-section/content', data)
        return promise.then(response => response.data)
    },

    deleteFicheSectionContent(data) {
        const promise = Api().post('/fiche-consultation/custom-section/delete', data)
        return promise.then(response => response.data)
    },

    activateConsultationFicheChamp(data) {
        const promise = Api().post('/fiche-consultation/fiche/activate-champs', data)
        return promise.then(response => response.data)
    },

    getListeDiagnosticDHIS2(data) {
        const promise = Api().post('/dhis2/diagnostics', data)
        return promise.then(response => response.data)
    },

    saveConsultationPlanTraitement(data) {
        const promise = Api().post('/consultations/store/plan-traitement', data)
        return promise.then(response => response.data)
    },
}